/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { AviPermissionResource } from 'generated-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

import { AlbServicesSiteItem } from 'ng/modules/items/factories/alb-services-site.item.factory';

export type TAlbServicesSiteCollection = typeof AlbServicesSiteCollection;

/**
 * @description Alb Service Site Collection Factory
 * @author Deepak Chaudhary
 */
export class AlbServicesSiteCollection extends Collection {
    public static readonly ngDependencies = [AlbServicesSiteItem];

    constructor(args = {}) {
        const extendedArguments = {
            objectName: 'albservices/site',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_SYSTEMCONFIGURATION,
            ...args,
        };

        super(extendedArguments);
        this.itemClass_ = this.getNgDependency(AlbServicesSiteItem);
    }
}
